import { APP_URL } from "../../../constants"

const Preview = ({document_url, id}) => {

  return (
    <div className="modal fade" id={id} tabIndex="-1"     aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            {/* <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> */}
            <div className="modal-body">
                {
                    document_url.includes('pdf') == 1 ? 
                        <div className='d-flex flex-end'>
                            <span className="">You are about to view a pdf file</span>
                            <a 
                            target='_blank'
                            className='ms-1' 
                            href={`${APP_URL}/${document_url}`}> click to view </a>
                        </div>
                     :
                    <img className='img-fluid' src={`${APP_URL}${document_url}`} alt="" />

                }
            </div>
            {/* <div className="modal-footer border-top-0">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div> */}
            </div>
        </div>
    </div>
  )
}

export default Preview